<template>
  <div class="home">
    <Intro/>
    <Benefits/>
    <staking-calculator/>
<!--    <Featured/>-->
<!--    <RoadMap/>-->
<!--    <Faq/>-->
<!--    <Subscribe/>-->
  </div>
</template>

<script>
import StakingCalculator from '../components/pages/home/StakingCalculator'
import Intro from "../components/pages/home/Intro";
import Benefits from "../components/pages/home/Benefits";
import Featured from "../components/pages/home/Featured";
import Faq from "../components/pages/home/Faq";
// import Subscribe from "../components/pages/home/Subscribe";
// import RoadMap from "../components/pages/home/RoadMap";

export default {
  name: 'Home',
  components: {
    StakingCalculator,
    Intro,
    Benefits,
    // Featured,
    // RoadMap,
    // Faq,
    // Subscribe
  }
}
</script>
